import { Card, Col, Form, Input, Row, Select } from "antd";
import { LIST_LEGAL_CATEGORIES, LIST_LEGAL_STRUCTURES } from "queries/centralApi/centralApi";
import { createOptionLegalStructures } from "utils/selectOptions";
import { clientCentralApiStrawberry } from "@neonumy/api-clients";
import NumberFormat from "components/NumberFormat";
import { AsyncSelect } from "@neonumy/ant-design";
import { useTranslation } from "react-i18next";
import { FaBuilding } from "react-icons/fa";
import CardTitle from "components/CardTitle";
const { TextArea } = Input;
import useBusinessActivities from "views/Settings/General/hooks/useBusinessActivities";

export default function CompanyInfoForm(): React.ReactElement {
  const { t } = useTranslation();
  const { options: businessActivityOptions, loading: businessActivityLoading } =
    useBusinessActivities();

  return (
    <Col xs={24} sm={12}>
      <Card
        title={<CardTitle icon={<FaBuilding />} title={t("Company informations")} />}
        className="antd-newrai-card no-border-top-left"
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} sm={8}>
            <Form.Item name="name" label={t("Company name")}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="displayName"
              label={t("Display name")}
              extra={<span className="form-extra-text">{t("Invoice display name")}</span>}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}></Col>
          <Col xs={24} sm={8}>
            <Form.Item name="vatNumber" label={t("SIRET")}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name="euVatNumber" label={t("TVA Intracom.")}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item name="capitalAmount" label={t("Capital")}>
              <NumberFormat />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item label={t("Code APE")} name="businessActivity">
              <Select
                showSearch
                options={businessActivityOptions}
                loading={businessActivityLoading}
                placeholder={t("Select business activity")}
                filterOption={(input, option) =>
                  (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="legalStructure"
              label={t("Legal form")}
              rules={[{ required: true, message: t("This field is required") }]}
            >
              <AsyncSelect
                optionsFormat={createOptionLegalStructures}
                hasQueryFilter={true}
                queryOptions={{
                  client: clientCentralApiStrawberry,
                  dataName: "listLegalStructures",
                  query: LIST_LEGAL_STRUCTURES,
                  variables: {
                    filter: {
                      search: "",
                    },
                  },
                }}
                translations={{
                  placeholder: t("Select legal structure"),
                  loadingMessage: t("Loading"),
                  noOptionsMessage: t("No Options"),
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              extra={
                <span>{"Numéro RCS et ville du greffe où l’entreprise est immatriculée"}</span>
              }
              name="rcs"
              label={t("RCS")}
            >
              <TextArea style={{ height: 32 }} />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item label={t("Legal Category")} name="legalCategory">
              <AsyncSelect
                queryOptions={{
                  client: clientCentralApiStrawberry,
                  dataName: "listLegalCategories",
                  query: LIST_LEGAL_CATEGORIES,
                  variables: {
                    search: "",
                  },
                }}
                translations={{
                  placeholder: t(""),
                  loadingMessage: t("Loading..."),
                  noOptionsMessage: t("No Options"),
                }}
                optionsFormat={item => ({
                  label: `${item.code} - ${item.name}`,
                  value: item.code,
                })}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </Col>
  );
}
